import React from 'react';
import { Button } from './Button';
interface IndividualProductCardProps {
  title: string;
  description: string;
  price: string;
  href: string;
  image?: string;
}
export function IndividualProductCard({
  title,
  description,
  price,
  href,
  image
}: IndividualProductCardProps) {
  return <div className="bg-brand-lightBlue rounded-2xl p-6 text-left flex flex-col" data-id="element-176">
      {image ? <div className="mb-4 flex justify-center" data-id="element-177">
          <img src={image} alt={title} className="h-48 w-auto object-contain" data-id="element-178" />
        </div> : <div className="text-4xl mb-3" data-id="element-179">📘</div>}
      <h3 className="text-lg font-bold text-brand-navy mb-3" data-id="element-180">{title}</h3>
      <p className="text-brand-navy text-sm mb-4 leading-relaxed flex-grow whitespace-pre-line" data-id="element-181">
        {description}
      </p>
      <div className="text-2xl font-black text-brand-pink mb-4" data-id="element-182">{price}</div>
      <Button href={href} className="w-full text-base" data-id="element-183">
        👉 COMPRAR AHORA
      </Button>
    </div>;
}